<template>
  <li class="u-border-graydb item-notice-area-row">
    <div class="c-card-row__inbox">
      <a :href="productURL" target="_blank">
        <div class="c-card-photo"><img v-bind:src="product.image" width="400" height="300" /></div>
        <div class="c-card-row__text">
          <p class="c-card__title ellipsis">{{product.shop_name}} {{product.name}}</p>
          <p class="c-card__tx1 ellipsis-row2">{{product.title}}</p>
          <p class="c-card__tx2 ellipsis-row2">{{product.lead_sentence}}</p>
        </div>
        <div class="c-flex-sp price-area-row">
          <p class="c-price-tx u-tx-right c-price-include-tx-area">
            <span class="c-price__num">{{product.price | numeral('0,0')}}</span>円
            <br>
            <span class="c-price-included-tx">(税込{{product.tax_included_price | numeral('0,0')}}円)</span>            
          </p>
          <div class="notice-area-row c-flex-sp">
            <button v-if="product.buy_status == 'buyable'" class="item-status u-buy-ok" @click.prevent="addCart(product.id)"><span>カートに入れる</span></button>
            <span v-else-if="product.campaign_status == 'before_start'" class="item-status u-lottery-wait">抽選応募開始前</span>
            <button v-else-if="product.campaign_status == 'appliable'" class="item-status u-lottery-ok"><span>抽選販売中</span></button>
            <button v-else-if="product.campaign_status == 'apply_finish'" class="item-status u-lottery-ok"><span>抽選販売中</span></button>
            <button v-else-if="product.campaign_status == 'applied'" class="item-status u-lottery-ok"><span>抽選販売中</span></button>
            <button v-else-if="product.campaign_status == 'check_result'" class="item-status u-lottery-ok"><span>当選結果確認</span></button>
            <span v-else-if="product.buy_status == 'before_release'" class="item-status u-wait">販売開始前</span>        
            <span v-else-if="product.buy_status == 'priority'" class="item-status u-priority-buy">優先販売中</span>
            <span v-else-if="product.buy_status == 'soldout'" class="item-status u-wait">販売終了</span>
            <span v-else-if="product.buy_status == 'premium_only'" class="item-status u-limited-buy">プレミアム限定</span>
            <span v-else class="item-status u-wait">入荷待ち</span>
            <div class="notice-area u-tx-right c-flex-sp">
              <div class="notice-select c-flex-sp">
                <p class="notice-btn">
                  <button v-if="isSignedIn == true && notifiedIds.includes(product.id) === true" @click.prevent=""><img src="~btn-notice-on.svg" width="30" height="30"></button>
                  <button v-else-if="isSignedIn == true && notifiedIds.includes(product.id) === false" @click.prevent="registerNotify(product.id)"><img src="~btn-notice-off.svg" width="30" height="30"></button>
                  <button v-else @click.prevent="showLoginNeededModal('入荷通知登録')"><img src="~btn-notice-off.svg" width="30" height="30"></button>
                </p>
                <p class="favorite-btn">
                  <button v-if="isSignedIn == true && favoritedIds.includes(product.id) === true" @click.prevent=""><img src="~btn-favorite-on.svg" width="30" height="30"></button>
                  <button v-else-if="isSignedIn == true && favoritedIds.includes(product.id) === false" @click.prevent="registerFavorite(product.id)"><img src="~btn-favorite-off.svg" width="30" height="30"></button>
                  <button v-else @click.prevent="showLoginNeededModal('お気に入り登録')"><img src="~btn-favorite-off.svg" width="30" height="30"></button>
                </p>
              </div>
            </div>
          </div>
      </div>
      </a>
    </div>
  </li>
</template>
<script>
import axios from 'axios';
import 'btn-favorite-on.svg';
import 'btn-favorite-off.svg';
import 'btn-notice-on.svg';
import 'btn-notice-off.svg';
import { addByGet } from '../cart';
export default {
  props: {
    product: {},
    isSignedIn: false,
    favoritedIds: [],
    notifiedIds: [],
  },
  computed: {
    productURL: function(){
      return "/products/" + this.product.id
    }
  },
  methods: {
    addCart: function(productId){
      addByGet(productId);
      return false;
    },
    
    showLoginNeededModal: function(action){
      alert(`${action}には、会員登録およびログインが必要です！`);
      e.preventDefault();      
      return false;
    },

    registerNotify: function(productId){
      axios
       .post(`/products/${productId}/notify.json`)
       .then(response =>{
        let newNotifiedIds = this.notifiedIds;
        newNotifiedIds.push(productId);
        this.notifiedIds = newNotifiedIds;
        alert(`入荷通知登録が完了しました！`);
      });      
    },

    registerFavorite: function(productId){
      axios
       .post('/favorites.json', {product_id: productId})
       .then(response =>{
        let newFavoritedIds = this.favoritedIds;
        newFavoritedIds.push(productId);
        this.favoritedIds = newFavoritedIds;
        alert(`お気に入り登録が完了しました！`);
      });
    },
  }
}
</script>